/* LovePTCGevoL — anchor Horizon's overflow ("More") panel directly under the More button. We don't inject DOM (Horizon's morph would strip it); we only set a CSS variable --lp-more-x = the More button's x offset within the overflow-list, which the compact-card CSS in lovptcg-brand.css uses to position the dropdown. */
(function () {
  function place(ol) {
    var moreLi = ol.querySelector("[slot='more']");
    if (!moreLi) return;
    var btn = moreLi.querySelector('button') || moreLi;
    var hr = ol.getBoundingClientRect();
    var br = btn.getBoundingClientRect();
    var x = Math.round(br.left - hr.left);
    if (x < 0) x = 0;
    ol.style.setProperty('--lp-more-x', x + 'px');
  }
  function bind() {
    var ol = document.querySelector('overflow-list.overflow-menu');
    if (!ol) return false;
    var moreLi = ol.querySelector("[slot='more']");
    if (!moreLi) return false;
    if (ol.__lpPlaced) return true;
    ol.__lpPlaced = true;
    var btn = moreLi.querySelector('button') || moreLi;
    var upd = function () { place(ol); };
    moreLi.addEventListener('pointerenter', upd);
    moreLi.addEventListener('mouseenter', upd);
    if (btn) { btn.addEventListener('focus', upd); }
    window.addEventListener('resize', upd);
    upd();
    return true;
  }
  function boot() {
    if (bind()) return;
    var n = 0;
    var iv = setInterval(function () { if (bind() || ++n > 60) clearInterval(iv); }, 150);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { boot(); });
})();
